import { Lock, Sparkles } from "lucide-react";
import { usePlan } from "@/context/PlanContext";
import { Button } from "@/components/ui/button";

export const PremiumLock = ({ title, description, needed = "standard", message, preview }) => {
  const { askUpgrade, plan } = usePlan();
  const planName = needed === "pro" ? "Pro" : "Standard";

  return (
    <div className="fade-up space-y-6" data-testid="premium-lock">
      <div className="flex flex-wrap items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-md bg-slate-200 text-slate-500">
          <Lock className="h-5 w-5" />
        </span>
        <div>
          <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
          <p className="text-sm text-slate-500">{description}</p>
        </div>
      </div>

      <div className="relative overflow-hidden rounded-lg border border-slate-200 bg-white">
        <div className="pointer-events-none select-none opacity-40 blur-[1.5px]">{preview}</div>
        <div className="absolute inset-0 flex items-center justify-center bg-white/50 p-6">
          <div className="max-w-sm rounded-lg border border-slate-200 bg-white p-6 text-center shadow-lg">
            <Lock className="mx-auto h-6 w-6 text-slate-400" />
            <h3 className="mt-3 text-lg font-semibold">Incluso nel piano {planName}</h3>
            <p className="mt-2 text-sm text-slate-500">
              {message || `Questa funzione è disponibile dal piano ${planName}.`} Il tuo piano attuale è{" "}
              <span className="font-semibold">{plan?.plan_name || "Gratuito"}</span>.
            </p>
            <Button
              className="mt-4 w-full"
              data-testid="premium-upgrade-btn"
              onClick={() => askUpgrade(title, message || `${title} è incluso nel piano ${planName}`, needed)}
            >
              <Sparkles className="mr-1.5 h-4 w-4" /> Passa a {planName}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
